import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router';

import { TicketContext } from '../../contexts/TicketContext';
import { TicketRoutePaths } from '../../interfaces/Routes';
import { useFormatting } from '../../services/hooks/useFormatting';
import Button from '../Button';
import { StepsUpdateContext } from '../Steps/StepsContext';

interface NavigationButtonProps {
  buttonAction: 'next' | 'prev';
  nextDisabled: boolean;
  onClickOverride?: () => void;
  preNavigateAction?: () => Promise<boolean>;
  text: string;
}

const NavigationButton: FunctionComponent<NavigationButtonProps> = ({
  text, buttonAction, nextDisabled, preNavigateAction, onClickOverride
}) => {
  const { completeCurrentStep, navigateToNextStep, navigateToPrevStep } = React.useContext(StepsUpdateContext);
  const { isInErrorMode } = React.useContext(TicketContext);
  const { formattedText: buttonText } = useFormatting(text);
  const { pathname } = useLocation();

  const handleNextButtonClick = async (): Promise<void> => {
    if (onClickOverride) {
      onClickOverride();
      return;
    }

    if (preNavigateAction) {
      const isSuccesfull = await preNavigateAction();

      if (!isSuccesfull) {
        return;
      }
    }

    completeCurrentStep();
    navigateToNextStep();
  };

  const handlePrevButtonClick = (): void => {
    if (onClickOverride) {
      onClickOverride();
      return;
    }

    navigateToPrevStep();
  };

  if (isInErrorMode) {
    return null;
  }

  return (
    <>
      {buttonAction === 'prev' && !pathname.includes(`/${TicketRoutePaths.change}`) && (
        <Button
          onClick={handlePrevButtonClick}
          text={buttonText}
          variant="outline"
        />
      )}

      {buttonAction === 'next' && (
        <Button
          disabled={nextDisabled}
          onClick={handleNextButtonClick}
          size="full"
          text={buttonText}
        />
      )}
    </>
  );
};

export default NavigationButton;
